
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_2df46_93",
  "root": "awsui_root_y1yrh_2df46_111",
  "has-default-filter": "awsui_has-default-filter_y1yrh_2df46_124",
  "chart-container": "awsui_chart-container_y1yrh_2df46_128",
  "chart-container__vertical": "awsui_chart-container__vertical_y1yrh_2df46_134",
  "chart-container__horizontal": "awsui_chart-container__horizontal_y1yrh_2df46_140",
  "content": "awsui_content_y1yrh_2df46_144",
  "content--reserve-filter": "awsui_content--reserve-filter_y1yrh_2df46_151",
  "content--reserve-legend": "awsui_content--reserve-legend_y1yrh_2df46_155",
  "series--highlighted": "awsui_series--highlighted_y1yrh_2df46_167",
  "series--dimmed": "awsui_series--dimmed_y1yrh_2df46_171",
  "series--threshold": "awsui_series--threshold_y1yrh_2df46_175",
  "popover-divider": "awsui_popover-divider_y1yrh_2df46_180"
};
  